import { Button, IconButton, Icon } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useSnackbar } from 'notistack';
import { isLocalUrl } from '@/lib/utils/DataFormat';

const useStyles = () => ({
  close: {
    position: 'absolute !important',
    top: '5px !important',
    right: '5px !important',
  },
});

export const Announcement = forwardRef((props, ref) => {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const displayAnnouncement = (announcement) => {
    let randkey = Math.random();

    enqueueSnackbar(announcement.message, {
      key: randkey,
      variant: 'default',
      autoHideDuration: 30000,
      resumeHideDuration: 20000,
      disableWindowBlurListener: false,
      action: (
        <React.Fragment>
          {announcement.actionLink && (
            <Button
              color="primary"
              size="small"
              variant="contained"
              startIcon={
                isLocalUrl(announcement.actionLink) ? null : <Icon>launch</Icon>
              }
              target={isLocalUrl(announcement.actionLink) ? '_self' : '_blank'}
              href={announcement.actionLink}
            >
              {announcement.actionText}
            </Button>
          )}

          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            sx={classes.close}
            onClick={() => closeSnackbar(randkey)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </React.Fragment>
      ),
    });
  };

  useImperativeHandle(ref, () => ({
    displayAnnouncement: (message) => {
      displayAnnouncement(message);
    },
  }));
});

Announcement.displayName = 'Announcement';

// export Announcement;
